export enum ESpecProjectType {
  /** Спецпроект ФСК **/
  Fsk = 'fsk',
}
